import React from 'react';
import { formSurfaceTheme } from './createAppTheme';
import { ThemeLayout } from './ThemeLayout';

export const FormThemeLayout: React.FC = () => (
  <ThemeLayout theme={formSurfaceTheme} mode="light" />
);
